'use client';

import { SchemaTopNavigationList } from './components/SchemaTopNavigationList';
import { Group, Stack } from '@mantine/core';
import { Form } from './components/Form';
import { FormOptions } from './components/FormOptions';

export const JsonForm = () => {
  return (
    <Stack gap='xs'>
      <FormOptions />
      <Group align='flex-start' wrap='nowrap'>
        <SchemaTopNavigationList />
        <Form />
      </Group>
    </Stack>
  );
};
